import React, { useCallback } from "react";
import FlusterButton from "../components/FlusterButton";
import FlusterCard from "../components/FlusterCard";
import _ from "lodash";
import Socket from "socket";

const FLUSFlusterIntro = ({
  roomId,

  isAnswererPlayer,
  isAroundTheHornIntro,
  screens
}) => {
  const answerer_player_ath_info = _.get(
    screens,
    "answerer.8_aroundthehornintro.button ",
    "START"
  );
  const answerer_player_fluster_info = _.get(
    screens,
    "answerer.5_flusterintro.button ",

    "BEGIN"
  );
  const flusterCardButtonAction = () => {
    if (isAnswererPlayer) {
      const data = {
        action: "update-status",
        roomId,
        tableTopName: "Fluster"
      };
      Socket.sendMessage(data);
    }
  };
  const handleFlusterStart = useCallback(
    _.debounce(() => flusterCardButtonAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );
  return (
    <div className="special-card-intro">
      <div className="question-card-main">
        <div
          className={`fluster-card-container ${
            isAnswererPlayer ? "" : "flus-single-card"
          }`}
        >
          <FlusterCard
            isSingleCard={true}
            isFluster={!isAroundTheHornIntro}
            isAroundTheHorn={isAroundTheHornIntro}
          />
        </div>
      </div>

      {isAnswererPlayer && (
        <FlusterButton
          text={
            isAroundTheHornIntro
              ? answerer_player_ath_info
              : answerer_player_fluster_info
          }
          onClick={handleFlusterStart}
          isQuestionScreen={true}
        />
      )}
    </div>
  );
};

export default FLUSFlusterIntro;
